
import { defineComponent } from 'vue';
import RangeInput from '@/components/RangeInput.vue';

export default defineComponent({
    components: {
        RangeInput,
    },

    props: {
        modelValue: {
            type: Number,
            required: true,
        },

        unit: {
            type: String,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup()
    {
        return {};
    },
})
